const CUR_SYM = { USD: "US$", CAD: "CA$", GBP: "£", EUR: "€" };
const money = (v, cur) => (v === null || v === undefined || v === "" ? "—" : `${CUR_SYM[cur] || "$"}${Number(v).toLocaleString(undefined, { minimumFractionDigits: 2 })}`);
const esc = (s) => String(s ?? "—").replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");

export function printRepairRequest(req) {
  const fields = [
    ["Date", req.date],
    ["Decision due", req.due_date],
    ["PO / RO #", req.po_ro],
    ["Description", req.description],
    ["Part number", req.part_number],
    ["Serial number", req.serial_number],
    ["Fleet type", req.fleet_type],
    ["Critical spares", req.critical_spares],
    ["Type of service", req.type_of_service],
    ["Estimated cost", money(req.estimated_cost, req.currency)],
    ["Evaluation fee (if denied)", money(req.evaluation_fee, req.currency)],
    ["Turnaround time", req.turnaround_time],
    ["Avg repair cost (RAAS)", money(req.avg_repair_cost, req.currency)],
    ["Current spares in stock", req.spares_in_stock],
    ["Consumption rate", req.consumption_rate],
    ["Min / Max details", req.min_max_details],
    ["RFQ 1", req.rfq1],
    ["RFQ 2", req.rfq2],
    ["RFQ 3", req.rfq3],
    ["Comments", req.comments],
  ];
  const statusLabel = { approved: "APPROVED", denied: "DENIED", revisit: "RE-VISIT", pending: "PENDING" }[req.status] || req.status;
  const decidedAt = String(req.decided_at || "").slice(0, 16).replace("T", " ");
  const revisitLine = req.status === "revisit" && req.revisit_timeframe
    ? `<div class="line">Re-visit in <strong>${esc(req.revisit_timeframe)}</strong> — by <strong>${esc(req.revisit_by)}</strong></div>` : "";
  const html = `<!doctype html><html><head><title>Repair Quote Approval — ${esc(req.po_ro || req.description)}</title>
<style>
  body { font-family: Georgia, 'Times New Roman', serif; color: #111; margin: 40px; }
  .head { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 3px solid #111; padding-bottom: 10px; }
  h1 { font-size: 20px; margin: 0; }
  .brand { font-size: 13px; letter-spacing: 2px; }
  .status { display: inline-block; margin-top: 14px; padding: 4px 12px; border: 2px solid #111; font-weight: bold; letter-spacing: 2px; font-size: 13px; }
  table { width: 100%; border-collapse: collapse; margin-top: 18px; font-size: 13px; }
  td { border: 1px solid #999; padding: 7px 10px; vertical-align: top; }
  td.k { width: 220px; font-size: 10px; text-transform: uppercase; letter-spacing: 1px; color: #555; background: #f4f4f4; }
  .decision { margin-top: 24px; border: 1px solid #999; padding: 14px 16px; }
  .decision h2 { font-size: 12px; text-transform: uppercase; letter-spacing: 2px; margin: 0 0 8px; color: #555; }
  .line { margin: 4px 0; font-size: 13px; }
  .sig { margin-top: 16px; font-style: italic; font-size: 22px; border-bottom: 1px solid #333; display: inline-block; padding: 0 40px 2px 4px; }
  .sigmeta { font-size: 10px; color: #555; margin-top: 4px; letter-spacing: 1px; }
  .foot { margin-top: 30px; font-size: 10px; color: #777; }
  @media print { body { margin: 16px; } }
</style></head><body>
  <div class="head"><h1>Repair Quote Approval Request</h1><div class="brand">SA · TRACKER</div></div>
  <div class="status">${statusLabel}</div>
  <table>${fields.map(([k, v]) => `<tr><td class="k">${esc(k)}</td><td>${esc(v)}</td></tr>`).join("")}
    <tr><td class="k">Requested by</td><td>${esc(req.created_by_name)}</td></tr>
    <tr><td class="k">Approver</td><td>${esc(req.approver_name)}</td></tr>
  </table>
  <div class="decision">
    <h2>Decision</h2>
    <div class="line">Status: <strong>${statusLabel}</strong>${req.decided_by_name ? ` by ${esc(req.decided_by_name)}` : ""}${decidedAt ? ` on ${decidedAt} UTC` : ""}</div>
    ${revisitLine}
    ${req.decision_comment ? `<div class="line">Comment: ${esc(req.decision_comment)}</div>` : ""}
    ${req.signature_name ? `<div class="sig">${esc(req.signature_name)}</div><div class="sigmeta">APPROVAL SIGNATURE · ${decidedAt} UTC</div>` : ""}
  </div>
  <div class="foot">Generated ${new Date().toISOString().slice(0, 16).replace("T", " ")} UTC · Request ID ${esc(req.id)}</div>
</body></html>`;
  const w = window.open("", "_blank", "width=900,height=1100");
  if (!w) return;
  w.document.write(html);
  w.document.close();
  setTimeout(() => { w.focus(); w.print(); }, 350);
}
